 <script>

import CommonService from '../../services/common';
import AutoComplete from 'primevue/autocomplete';
import Button from 'primevue/button';


export default {
    components: { 
        AutoComplete, Button 
    },
    props: ['refLabel', 'disabled', 'api', 'sortField','changeFn', 'name', 'disableStore', 'compileIfOnly', 'modelValue', 'addEmpty', 'emptyValue', 'emptyLabel', 'format', 'defaultValue', 'queryValue'],
    emits: ['update:modelValue'],
    data(){
        return {
            v: null,
            filteredOptions: [],
            dynamicOptions: [],
            firstLoading: true
        }
    },
    mounted(){
        this.loadOptions();
        this.refreshValue();
        this.firstLoading = true;
    },
    created(){
    },
    computed: {
        options(){
            let store = this.disableStore ? this.dynamicOptions : this.$store.state.masterData[this.name];
            if(store && this.addEmpty){
                return [{label: this.emptyLabel, value: this.emptyValue}, ...store];
            }
            return store;
        },
        storeName(){
            if(this.name){
                return this.name;
            }
            return this.api;
        }
    },
    watch: {
        options(){
            this.refreshValue();
        },
        modelValue(){
            this.refreshValue();
        }
    },
    methods: {
        getCompleteValue(){
            return this.v;
        },
        refreshValue(){
            let store = this.options;
            if(store && store.length > 0){
                let modelValue = this.modelValue;
                if(!this.v || this.v.value != modelValue){
                    let found = store.filter((el) => {
                        return el.value == modelValue;
                    });
                    if(found.length > 0){
                        this.v = found[0];

                        if(this.changeFn){
                            this.changeFn(found[0], this.refLabel)
                        }
                    }

                    if(this.compileIfOnly && store.length == 1){
                        this.v = store[0];
                        this.$emit('update:modelValue', this.v.value);

                        if(this.changeFn){
                            this.changeFn(store[0], this.refLabel)
                        }
                    }
                }

                if(this.queryValue && this.firstLoading){
                    let f = [];
                    if(this.name == 'vessel-nomination-tax-warehouse-combo'){
                        let spl = this.queryValue.split('|');
                        let consigneeExciseCode = spl[0] ?? null;
                        let placeOfDeliveryExciseCode = spl[1] ?? null;
                        if(placeOfDeliveryExciseCode){
                            f = store.filter((el) => el.extraData.consigneeExciseCode == consigneeExciseCode && el.extraData.placeOfDeliveryExciseCode == placeOfDeliveryExciseCode);
                        }else{
                            f = store.filter((el) => el.extraData.consigneeExciseCode == consigneeExciseCode);
                            if(f.length != 1){
                                f = [];
                            }
                        }
                    }else{
                        let regex = new RegExp(this.queryValue, "i");
                        f = store.filter((el) => {
                            return regex.test(el.extraData?.aliasVesselNominationAI);
                        })
                        if(f.length == 0){
                            f = store.filter((el) => {
                                return regex.test(el.label);
                            })
                        }
                    }
                    if(f.length > 0){
                        this.v = f[0];
                        this.$emit('update:modelValue', this.v.value);
                        if(this.changeFn){
                            this.changeFn(this.v, this.refLabel)
                        }
                        this.firstLoading= false;
                    }
                }
            }

        },
        loadOptions(){

            if(this.disableStore || !this.options){
                this.forceLoadOptions();
            }
        },
        forceLoadOptions(api = null){
            if(this.api || api){
                let params = {};
                if(this.sortField){
                    params = {
                        sort: JSON.stringify([{property: this.sortField, direction: 'asc'}])
                    };
                }

                let payload = {
                    params: params,
                    name: this.name,
                    api: api ?? this.api
                };
                if(this.disableStore){
                    CommonService.loadGeneric(api ?? this.api, params, ({success, data}) => {
                        if(success){
                            this.dynamicOptions = [];
                            this.dynamicOptions.push(...data);
                            if(this.defaultValue){
                                this.v = this.dynamicOptions.find((item) => item.label === this.defaultValue);
                                this.$emit('update:modelValue', this.v.value);
                            }
                        }
                    });
                }else{
                    this.$store.dispatch("masterData/loadData", payload);
                }
            }
        },
        filter(event){
            if (!event.query.trim().length) {
                this.filteredOptions = [...this.options];
            }
            else {
                this.filteredOptions = this.options.filter((item) => {
                    return item.label.toLowerCase().includes(event.query.toLowerCase());
                });
            }
        },
        onItemSelect(e){
            this.$emit('update:modelValue', e.value.value);
            if(this.changeFn){
                let store = this.disableStore ? this.dynamicOptions : this.$store.state.masterData[this.name];
                let p = store.filter((el) => {
                    return el.value == e.value.value;
                });
                if(p && p.length > 0){
                    this.changeFn(p[0], this.refLabel)
                }
            }
        },
        blurEvent(){
            if(this.v == null){
                this.$emit('update:modelValue', null);
            }
        },
        queryFilter(t, applyFirst = false){
            this.v = t;
            this.filter({query: t})
            if(applyFirst){
                if(this.options && this.options.length > 0){
                    this.v = this.options[0];
                    this.$emit('update:modelValue', this.v.value);

                    if(this.changeFn){
                        this.changeFn(this.options[0], this.refLabel)
                    }
                }
            }else{
                this.$refs.autoc.show();
            }
        },
        queryFilterWithDefault(t){
            this.v = t;
            this.filter({query: t})
            if(this.filteredOptions && this.filteredOptions.length > 0){
                if(this.filteredOptions.length == 1){
                    this.v = this.filteredOptions[0];
                    this.$emit('update:modelValue', this.v.value);

                    if(this.changeFn){
                        this.changeFn(this.filteredOptions[0], this.refLabel)
                    }
                }else{
                    this.$refs.autoc.show();
                }
            }
        }
    }
}

/**
:field="field"
v-model="data[field.name]" 
:disabled="disabled || field.readOnly || (field.disabledInEdit && id != 0)" 
:api="field.selectApi"
:sortField="field.sortField ?? null"
v-if="field.type == 'select'" 
:format="field.selectFormat"
**/
</script>

<style>

    .p-invalid > span > input, .p-invalid > div > input, .p-invalid > button{
        border-color: #B00020 !important;
    }

</style>


<template>
    <div class="p-inputgroup">
        <Button icon="pi pi-refresh" class="p-button-outlined" @click="forceLoadOptions(null)" :disabled="disabled" style="background-color: white;"/>
        <AutoComplete ref="autoc" 
            :disabled="disabled"
            field="label"
            v-model="v"
            :format="format"
            :suggestions="filteredOptions" 
            dropdown forceSelection 
            @complete="filter($event)"
            @item-select="onItemSelect"
            v-on:blur="blurEvent">
                <template #item="slotProps">
                    <div class="ml-2">{{slotProps.item.label}}</div>
                </template>
        </AutoComplete>
    </div> 
</template>

